import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { observable } from 'mobx'
import i18n from 'i18next'

import Button from '../../UniformComponents/Button'

const SCROLL_THRESHOLD = 20

@observer
export default class PageSwitchTab extends Component {
    @observable scrollStart = 0

    @observable scrollFinish = 0

    @observable isScrollingDown = false

    constructor(props) {
        super(props)
        this.availableTabs = this.getAvailableTabs()
        this.state = {
            isVisible: true,
        }
    }

    componentDidMount = () => {
        window.addEventListener('scroll', this.handleScroll, { passive: true })
        this.scrollFinish = window.scrollY
        this.scrollStart = window.scrollY
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll)
    }

    goToTab = (tabName) => {
        const { history } = this.props
        if (tabName) history.push(tabName)
    }

    getAvailableTabs = () => {
        const { props } = this
        const { tabOptions, appStore } = props
        let availableTabs = []
        switch (tabOptions.name) {
            case 'manageEvents':
                availableTabs = tabOptions.tabs?.filter((tab) => {
                    if (tab.value === 'divisions' && !props.hasMultiDivision) return false
                    return tab.checkPermission(appStore)
                })
                break
            case 'questions':
                availableTabs = tabOptions.tabs?.filter(
                    (tab) => tab.checkPermission(appStore),
                )
                break
            case 'templates':
                availableTabs = tabOptions.tabs?.filter(
                    (tab) => tab.checkPermission(appStore),
                )
                break
            default:
                break
        }
        return availableTabs
    }

    isTabActive = (tab) => {
        const { location } = this.props
        return tab.path.startsWith(location.pathname)
    }

    handleScroll = () => {
        const currentYPos = window.scrollY
        const { isVisible } = this.state
        if (currentYPos < SCROLL_THRESHOLD && !isVisible) this.setState({ isVisible: true })
        const isCurrentlyScrollingDown = currentYPos > this.scrollFinish

        const hasDirectionChanged = isCurrentlyScrollingDown !== this.isScrollingDown
        if (hasDirectionChanged) {
            this.scrollStart = currentYPos
            this.isScrollingDown = isCurrentlyScrollingDown
        }

        const scrollDistance = Math.abs(currentYPos - this.scrollStart)
        if (scrollDistance > SCROLL_THRESHOLD) {
            const shouldBeVisible = !this.isScrollingDown
            if (shouldBeVisible !== isVisible) {
                this.setState({ isVisible: shouldBeVisible })
                this.scrollStartY = currentYPos
            }
        }
        this.scrollFinish = currentYPos
    }

    getTabName = (value) => {
        const { industryVENU } = this.props
        if (value === 'events') {
            if (industryVENU.hasOnlyVENU) return 'venues'
            if (industryVENU.hasVENU) return 'venues_events'
        }
        return value
    }

    render() {
        const { tabOptions } = this.props
        const { isVisible } = this.state
        return (
            <div className={`switch-button ${isVisible ? '' : 'hide-tabs'}`}>
                <ul className="tabs">
                    {this.availableTabs.length > 1
                    && this.availableTabs.map((tab) => (
                        <li key={tab.key}>
                            <Button
                                type="button"
                                onClick={() => this.goToTab(tab.path)}
                                cssClass={`${tabOptions.name === 'manageEvents' ? 'compact' : ''} ${this.isTabActive(tab) ? 'active' : ''}`}
                            >
                                <i className={`fa-regular ${tab.icon ?? 'fa-square-poll-vertical'}`} />
                                {i18n.t(this.getTabName(tab.value))}
                            </Button>
                        </li>
                    ))}
                </ul>
            </div>
        )
    }
}
